import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-RequestTermination',
    templateUrl: './RequestTermination.component.html'
})
export class RequestTerminationComponent implements OnInit {

    consumerID: string;
    status_code = 503;
    message: string;
    content_type = 'application/json; charset=utf-8';
    body: string;

    data = {
        'consumerID' : this.consumerID,
        'status_code' : this.status_code,
        'message' : this.message,
        'content_type' : this.content_type,
        'body' : this.body,
        'plugin' : 'request-termination'
    };

    constructor() { }

    ngOnInit() {
    }

}
